import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    paddingTop: 52,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  saveButton: {
    borderRadius: 5,
  },
  cancelButton: {
    color: theme.palette.common.black,
    borderRadius: 5,
    fontWeight: 500,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 34,
  },
}));
